export default __webpack_public_path__ + "static/media/door_gifts.5c9f105b.svg";